import { useState, useEffect } from 'react';
import styled, { css } from "styled-components";
import moment from 'moment';
import Modal from './Modal';

const styles = css`
  display: flex;
  flex-direction: row;
  gap: 0px;
  min-width: 600px;
  & .col {
    min-width: 20rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    border-left: 1px solid ${props => props.theme.borderColor.primary};
    &:nth-of-type(1) {
      border-left: none;
    }
  }
  & .checkbox {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 20px;
  }
`
const EditFaq = ({ className, isOpen = true, user = null, onConfirm, onCancel }) => {
  const [firstname, setFirstname] = useState(user?.firstname ?? '');
  const [lastname, setLastname] = useState(user?.lastname ?? '');
  const [email, setEmail] = useState(user?.email ?? '');
  const [role, setRole] = useState(user?.role ?? 'user');
  const [forcePWChange, setForcePWChange] = useState(user?.forcePWChange);
  const [forceLogin, setForceLogin] = useState(user?.forceLogin);
  const [isSaveDisabled, setIsSavedDisabled] = useState(true);

  useEffect(() => {
    if (firstname && lastname && email && role) {
      setIsSavedDisabled(false);
    } else {
      setIsSavedDisabled(true);
    }
  }, [firstname, lastname, email, role]);

  const save = () => {
    
    onConfirm({
      id: user?.id,
      firstname,
      lastname,
      email,
      role,
      forcePWChange,
      forceLogin,
    });
    setFirstname('');
    setLastname('');
    setEmail('');
    setRole('');
    setForceLogin(false);
    setForcePWChange(false);
  }

  return (
    <Modal isShowing={isOpen} title={`${user ? 'Edit User' : 'Invite New User'}`} confirmText='Save' cancelText='Cancel' onConfirm={isSaveDisabled ? null : save} onCancel={onCancel}>
      <div className={className}>
        <div className={'col'}>
          <div>First Name</div>
          <input value={firstname} onChange={e => setFirstname(e.target.value)} />
          <div>Last Name</div>
          <input value={lastname} onChange={e => setLastname(e.target.value)} />
          <div>Email</div>
          <input value={email} onChange={e => setEmail(e.target.value)} />
          <div>Role</div>
          <select value={role} onChange={e => setRole(e.target.value)} >
            <option value='user'>User</option>
            <option value='admin'>Admin</option>
          </select>
        </div>
        {user &&
          <>
            <div className='col'>
              <div>Phone</div>
              <input disabled value={user.phone} />
              <div>Address</div>
              <input disabled value={user.address} />
              <div>Last Login</div>
              <input disabled value={user.lastLogin ? moment(user.lastLogin).format('MMM DD, YYYY HH:mm:ss') : 'Never'} />
              <div>Last PW Change</div>
              <input disabled value={user.lastPWChange ? moment(user.lastPWChange).format('MMM DD, YYYY HH:mm:ss') : 'Never'} />
            </div>
            <div className='col'>
              <div className='checkbox'>
                <input type='checkbox'  checked={forcePWChange} onChange = {e => setForcePWChange(e.target.checked)} />
                <span>Force Password Change</span>
              </div>
              <div className='checkbox'>
                <input type='checkbox'  checked={forceLogin} onChange = {e => setForceLogin(e.target.checked)} />
                <span>Force Login</span>
              </div>
            </div>
          </>
        }
      </div>
    </Modal>
  )
}

export default styled(EditFaq)`${styles}`;